<template lang="pug">
  div.wrap-visualization-item-message-text
    div(:class="bubbleShape")
      div.wrap-message
        div.message.bubble.px10.py8
          span.fz11 {{message.value}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/animation.scss";
// @import "@/scss/doodleAnimation.scss";

.wrap-visualization-item-message-text {
  .wrap-message {
    // white-space: pre-wrap;
    // word-wrap: break-word;
    letter-spacing: 1.4px;
    .bubble {
      color: $primary_bg_color;
      background: $primary_text_color;
      border-radius: 16px;
      filter: $drop_shadow;
    }
  }
}
</style>

<script>

export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  computed: {
    bubbleShape () {
      return `shape-${this.message.type}`
    }
  },
  created () {
    
  }
}
</script>
